<template>
  <div class="space-y-6">
    <div class="grid gap-4">
      <button
        v-for="option in goals"
        :key="option.value"
        @click="select(option.value)"
        :class="['btn', 'btn-outline', 'w-full', selected === option.value ? 'btn-primary' : '']">
        {{ $t(option.label) }}
      </button>
    </div>

    <div class="text-center">
      <button class="btn btn-primary mt-6" :disabled="!selected" @click="$emit('next')">
        {{ $t("smartLeadForm.next") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";

interface ConsultationLeadData {
  goal?: string;
  name?: string;
  email?: string;
  need?: string;
  subscribe?: boolean;
}

// now accept our full lead shape
const props = defineProps<{
  modelValue: ConsultationLeadData;
  "onUpdate:modelValue": (val: ConsultationLeadData) => void;
  onNext?: (event?: any) => void;
}>();
const emit = defineEmits(["update:modelValue", "next"]);

const selected = ref(props.modelValue.goal || "");

const goals = [
  { value: "getClients", label: "smartLeadForm.step2.options.getClients" },
  { value: "showcase", label: "smartLeadForm.step2.options.showcase" },
  { value: "sellProducts", label: "smartLeadForm.step2.options.sellProducts" },
  { value: "needHelp", label: "smartLeadForm.step2.options.needHelp" },
];

watch(selected, val => {
  emit("update:modelValue", { ...props.modelValue, goal: val });
});

function select(value: string) {
  selected.value = value;
}
</script>
